"use client"
/* */
import { jsxs, jsx } from 'react/jsx-runtime';
import React from 'react';
import '@tabler/icons-react';
import '../../../../../Icon/Icon.mjs';
import '../../../../../../lib/viewComponentContext/viewComponentContext.mjs';
import { IconFilter } from '../../../../../Icon/components/icons/IconFilter.mjs';
import ButtonView from '../../../../../../views/ButtonView.mjs';
import { ContextMenu } from '../../../../../ContextMenu/ContextMenu.mjs';
import '../../../../../MenuItem/MenuItem.mjs';
import { ContextMenuTrigger } from '../../../../../ContextMenu/components/ContextMenuTrigger/ContextMenuTrigger.mjs';
import 'react-aria-components';
import '../../../../../ContextMenu/components/ContextMenuSection/ContextMenuSection.mjs';
import 'invariant';
import 'luxon';
import 'clsx';
import '../../../../../../lib/propsContext/propsContext.mjs';
import '@mittwald/react-tunnel';
import '../../../../../../lib/slotContext/slotContext.mjs';
import '@react-aria/utils';
import 'remeda';
import 'dot-prop';
import '../../../../../Heading/Heading.mjs';
import '../../../../../Text/Text.mjs';
import locales from '../../../../../../../../_virtual/_.locale.json@8d5024994f97657f895a4e2a188d2d8a.mjs';
import { useLocalizedStringFormatter } from 'react-aria';
import '../../../../../ColumnLayout/ColumnLayout.mjs';
import '../../../ListSummary/ListSummary.mjs';
import { useList } from '../../../../hooks/useList.mjs';
import '../../../../List.mjs';
import HeadingView from '../../../../../../views/HeadingView.mjs';
import { FilterMenuItem } from './FilterMenuItem.mjs';
import headerStyles from '../../Header.module.css.mjs';
import ContextMenuSectionView from '../../../../../../views/ContextMenuSectionView.mjs';
import SeparatorView from '../../../../../../views/SeparatorView.mjs';

const CombinedFilterMenu = () => {
  const list = useList();
  const filters = list.filters;
  const stringFormatter = useLocalizedStringFormatter(locales);
  if (filters.length === 0) {
    return null;
  }
  return /* @__PURE__ */ jsxs(ContextMenuTrigger, { children: [
    /* @__PURE__ */ jsx(
      ButtonView,
      {
        className: headerStyles.mobile,
        variant: "outline",
        color: "secondary",
        "aria-label": stringFormatter.format("list.filters"),
        children: /* @__PURE__ */ jsx(IconFilter, {})
      }
    ),
    /* @__PURE__ */ jsx(ContextMenu, { children: filters.map((f, i) => {
      const activeFilterKeys = f.values.filter((v) => v.isActive).map((v) => v.id);
      return /* @__PURE__ */ jsxs(React.Fragment, { children: [
        /* @__PURE__ */ jsxs(
          ContextMenuSectionView,
          {
            selectionMode: f.mode === "one" ? "single" : "multiple",
            selectedKeys: activeFilterKeys,
            children: [
              /* @__PURE__ */ jsx(HeadingView, { children: f.name ?? f.property }),
              f.values.map((v) => /* @__PURE__ */ jsx(FilterMenuItem, { filterValue: v }, v.id))
            ]
          }
        ),
        i + 1 < filters.length && /* @__PURE__ */ jsx(SeparatorView, {})
      ] }, f.property);
    }) })
  ] });
};

export { CombinedFilterMenu };
//# sourceMappingURL=CombinedFilterMenu.mjs.map
